export {
  KeyboardNavigator,
  type NavigatorMode,
  type NavigatorLayout,
  type LinearLayout,
  type GridLayout,
  type KeyboardNavigatorOptions,
  type FocusChangeEvent,
  type FocusChangeListener,
} from "./KeyboardNavigator";

export type PointerKind = "mouse" | "touch" | "pen";

export function pointerKind(event: PointerEvent): PointerKind {
  if (event.pointerType === "touch") return "touch";
  if (event.pointerType === "pen") return "pen";
  return "mouse";
}

export interface DrawingSize {
  readonly width: number;
  readonly height: number;
}

/**
 * Map a PointerEvent's viewport coordinates into the canvas's drawing space.
 *
 * The canvas may be stretched in CSS (mobile fill) or scaled via
 * `ctx.scale(dpr, dpr)` for HiDPI. We normalize against the canvas's
 * bounding rect so the result matches the coordinate system the rendering
 * code uses — independent of viewport zoom and devicePixelRatio.
 */
export function canvasCoordsFromEvent(
  event: PointerEvent,
  canvas: HTMLCanvasElement,
  drawing: DrawingSize,
): { x: number; y: number } {
  const rect = canvas.getBoundingClientRect();
  const x = ((event.clientX - rect.left) / rect.width) * drawing.width;
  const y = ((event.clientY - rect.top) / rect.height) * drawing.height;
  return { x, y };
}
